import { Flex, NumberFormat, SkeletonBox, Text } from '@billy/design-system'
import { PropsWithChildren, ReactElement } from 'react'

import { getCurrentLocale } from '../../../../../../../../utils'

const SUMMARY_ITEM_LOADER_HEIGHT = 24

interface SalesReportSummaryItemProps extends PropsWithChildren {
  isLoading?: boolean
  shouldFormatNumber?: boolean
  value: number
}

export const SalesReportSummaryItem = ({
  children,
  isLoading,
  shouldFormatNumber,
  value,
}: SalesReportSummaryItemProps): ReactElement => {
  const locale = getCurrentLocale()
  const itemAmount = NumberFormat.getFormattedNumber(
    value,
    locale,
    shouldFormatNumber ? { minimumFractionDigits: 2, maximumFractionDigits: 2 } : {},
  )

  return (
    <Flex flexDirection="column" alignItems="flex-start">
      <Text uppercase variant="bodySM" colorVariant="secondary">
        {children}
      </Text>
      {isLoading ? (
        <SkeletonBox height={SUMMARY_ITEM_LOADER_HEIGHT} fullWidth />
      ) : (
        <Text title={itemAmount} truncate variant="h4" weight="regular">
          {itemAmount}
        </Text>
      )}
    </Flex>
  )
}
